// Module
var code = "<react-component name=\"ConsentClausesList\"></react-component>\n";
// Exports
module.exports = code;